import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'

import { redirectToAllianz } from './redirectToAllianz'

export const redirectToAllianzWeb = () => {
  return {
    ...redirectToAllianz(),
    onSubmit: {
      type: 'dispatchedHook',
      callbackConfig: {
        name: 'redirectToAllianzSite',
        options: {
          redirectURL:
            'https://www.allianz.de/angebot/kooperation/gesundheit/zahnzusatzversicherung/rechner/#getsafe_zahn',
        },
        inputs: [],
        outputs: [],
      },
    },
    footer: {
      defaultButton: {
        buttonLabel: {
          type: 'translatableText',
          translationKey: 'sharedFlows_dental:steps.dental_redirect_to_allianz.buttonLabel',
        },
      },
      hideBackButton: true,
    },
  } as const satisfies AnyStepConfiguration
}
